export const DEFAULT_HORIZONTAL_PANEL_DIRECTION = Object.freeze({
  enterX: '110%',
  exitX: '-110%',
});

const REVERSE_HORIZONTAL_PANEL_DIRECTION = Object.freeze({
  enterX: '-110%',
  exitX: '110%',
});

export const HORIZONTAL_PANEL_TRANSITION = Object.freeze({
  type: 'tween',
  duration: 0.34,
  ease: Object.freeze([0.32, 0.72, 0, 1]),
});

export const HORIZONTAL_PANEL_VARIANTS = Object.freeze({
  enter: ({ enterX = DEFAULT_HORIZONTAL_PANEL_DIRECTION.enterX } = {}) => ({
    transform: `translate3d(${enterX}, 0, 0)`,
    opacity: 0,
  }),
  center: {
    transform: 'translate3d(0%, 0, 0)',
    opacity: 1,
  },
  exit: ({ exitX = DEFAULT_HORIZONTAL_PANEL_DIRECTION.exitX } = {}) => ({
    transform: `translate3d(${exitX}, 0, 0)`,
    opacity: 0,
  }),
});

export function getIndexedHorizontalPanelDirection(currentIndex, nextIndex) {
  const direction = nextIndex > currentIndex
    ? DEFAULT_HORIZONTAL_PANEL_DIRECTION
    : REVERSE_HORIZONTAL_PANEL_DIRECTION;

  return { ...direction };
}
